import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const InlineMessage = ({ type = 'danger', display = true, text, handleClose = null }) =>
  (display && (
    <div
      className={classnames('alert', `alert-${type}`, {
        'alert-dismissible fade show': !!handleClose,
      })}
    >
      {handleClose && (
        <button
          className="close"
          onClick={(e) => {
            e.preventDefault();
            handleClose(e);
          }}
        >
          <i className="fa fa-times-circle" />
        </button>
      )}

      <i
        className={classnames('icon', 'fa', 'fa-lg', {
          'fa-times': type === 'danger',
          'fa-info': type === 'info',
          'fa-check': type === 'success',
          'fa-exclamation': type === 'warning',
        })}
      />

      {text}
    </div>
  )) ||
  null;

InlineMessage.propTypes = {
  type: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
  display: PropTypes.bool,
  text: PropTypes.string,
  handleClose: PropTypes.func,
};

export default InlineMessage;



// WEBPACK FOOTER //
// src/modules/messages/components/InlineMessage.js